'use strict';

var DEFAULT_LIGHT_TEXT_COLOR = "#FBFBFE";
var DEFAULT_DARK_TEXT_COLOR = "#272522";
var DEFAULT_TEXT_COLOR = "#000000";

exports.DEFAULT_DARK_TEXT_COLOR = DEFAULT_DARK_TEXT_COLOR;
exports.DEFAULT_LIGHT_TEXT_COLOR = DEFAULT_LIGHT_TEXT_COLOR;
exports.DEFAULT_TEXT_COLOR = DEFAULT_TEXT_COLOR;
//# sourceMappingURL=Colors.constants.js.map
